import React, { useState, useRef, useEffect } from 'react';
import { Box, Checkbox, DialogContent, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Select, Stack, Switch, TextField, Typography, useMediaQuery } from '@mui/material';
import { withRouter } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import _ from 'lodash';
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import momenttz from "moment-timezone";
import BaseModal from '../../UserScreen/InventoryPage/InventorySettings/components/BaseModal/BaseModal';
import SidebarTabs from '../../UserScreen/InventoryPage/InventorySettings/components/SidebarTabs/SidebarTabs';
import { useTheme } from '@mui/material/styles';
import ModalFooter from '../../UserScreen/InventoryPage/InventorySettings/components/ModalFooter/ModalFooter';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import TemplateInfo from './TemplateInfo';
import QuotaActions from './QuotaActions';
import Notifications from './Notifications';

import { createTemplate, editTemplate, getStarlinkTemplate } from '../StarlinkPooled/slice';
import moment from 'moment-timezone';


const NewCreatePlanPopup: React.FC<any> = ({ open, row, selectedOu, createTemplate, setOpen, createPlanTemplate, callPlanHierarchyAPI, editTemplate, editPlanTemplate, getStarlinkTemplate, setEditRow, editRow }) => {
    const [activeTabIndex, setActiveTabIndex] = useState<number>(0);
    const [refreshIconClicked, setRefreshIconClicked] = useState(true);
    const [planPoolToggle, setPlanPoolToggle] = useState(editRow?.type == "customPlan" ? "Plan" : "Pool") 
    const handlePlanPoolToggle = (val) => { setPlanPoolToggle(val) }
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [revertEntries, setRevertEntries] = useState<any>([{ usagePercentage: 0, type: 'resumeServiceLine', revert: true }, { usagePercentage: 0, type: 'optIn', revert: true }]);
    const [entries, setEntries] = useState<any>([{ usagePercentage: '70', type: 'sendNotification' }, { usagePercentage: '100', type: 'optOut' }]);
    const [emailInput, setEmailInput] = useState('');
    const [emails, setEmails] = useState<any>([]);
    const [error, setError] = useState('');
    const tabs = ['Template Info', 'Quota Kontrol', 'Notifications'];
    const isEditMode = !!editRow?.id;
    const [selectedMonthYear, setSelectedMonthYear] = useState(
        moment()
    );
    const [day, setDay] = useState({label: "1", value: 1});
    const [currentSubPool, setCurrentSubPool] = useState<any>({
        poolName: '',
        poolSize: '',
        unit: 'tb',
        startDate: moment().startOf('month').format("YYYY-MM-DD"),
        duration: 'monthly',
        isRecurring: true,
        selectedDp: null,
        poolInfo: '',
        assignedBy: '',
        dpId: '',
        data: null,
    });

    useEffect(() => {
        setPlanPoolToggle(editRow?.type == "customPlan" ? "Plan" : "Pool");
    },[editRow])
    
    useEffect(() => {
        if (editRow && editRow.id) {
            setActiveTabIndex(0);
            const actions = editRow.quota_actions || [];
            const normalActions = actions.filter(a => !a.revert);
            const revertActions = actions.filter(a => a.revert);
            const startMoment = moment(editRow.start_date, "YYYY-MM-DD");
            const lastDayOfMonth = startMoment.daysInMonth();
            setSelectedMonthYear(startMoment);
            setDay({
                label: startMoment.date() == lastDayOfMonth ? "Last Day" : String(startMoment.date()), 
                value: startMoment.date()
            });
            setSelectedMonthYear(moment(editRow.start_date))
            setCurrentSubPool({
                poolName: editRow.plan_name,
                poolSize: editRow.plan_size,
                unit: editRow.unit,
                startDate: moment(editRow.start_date).format("YYYY-MM-DD"),
                duration: editRow.duration,
                isRecurring: editRow.is_recurring,
                selectedDp: null, // you can set if available
                poolInfo: editRow.plan_info,
                assignedBy: '',
                dpId: editRow.dp_id,
                data: null,
            });

            setEntries(normalActions);
            setRevertEntries(revertActions);
            setEmails(editRow.users_to_notify || []);
        }
    }, [editRow]);


    const handleTabChange = (_: string, index: number, profileId?: string) => { setActiveTabIndex(index); };

    const getFirstDayOfMonth = () => { return momenttz().utc().startOf('month').hours(0).minutes(0).seconds(0).milliseconds(0); };

    const handleSave = () => {
        if (activeTabIndex === 2) {
            if (emailInput.trim() !== "") {
                setError("Press Enter to add the email .");
                return;
            }
            handleCreatePlanTemplate()
        } else { setActiveTabIndex(activeTabIndex + 1) }
    };

    useEffect(() => {
        if (!_.isEmpty(createPlanTemplate) || !_.isEmpty(editPlanTemplate)) {
            clearData();
            setActiveTabIndex(0);
            setOpen(false);
            callPlanHierarchyAPI()
            setEditRow(null)
        }
    }, [createPlanTemplate, editPlanTemplate]);

    const clearData = () => {
        setCurrentSubPool({
            poolName: '',
            poolSize: '',
            unit: 'tb',
            startDate: moment().startOf('month').format("YYYY-MM-DD"),
            duration: 'monthly',
            isRecurring: true,
            selectedDp: null,
            poolInfo: '',
            assignedBy: '',
            dpId: '',
            data: null
        })
        setSelectedMonthYear(moment());
        setDay({label: "1", value: 1});
        setEmails([]);
        setEntries([{ usagePercentage: '70', type: 'sendNotification' }, { usagePercentage: '100', type: 'optOut' },]);
    }

     const isTemplateInfoValid = () => {
      const { poolName, poolInfo, poolSize } = currentSubPool;
      return ( !!poolName?.trim() && !!poolInfo?.trim() && !!poolSize &&  currentSubPool.poolSize > 0);
    };

    const handleCreatePlanTemplate = () => {
        if (isEditMode) {
            let params = {
                templateId: editRow?.id,
                planName: currentSubPool?.poolName,
                templateInfo: currentSubPool?.poolInfo,
                dpId: selectedOu?.id,
                quotaActions: [...entries, ...revertEntries],
                usersToNotify: emails,
                isRecurring: currentSubPool?.isRecurring ? true : false,
                notificationMethods: ['email']
            }
            editTemplate(params)
        } else {
            let params = {
                planName: currentSubPool?.poolName,
                planSize: currentSubPool?.poolSize,
                startDate: currentSubPool?.startDate,
                templateInfo: currentSubPool?.poolInfo,
                unit: currentSubPool?.unit,
                duration: currentSubPool?.duration,
                type: planPoolToggle === "Plan" ? "customPlan" : "orgPool",
                dpId: selectedOu?.id,
                quotaActions: [...entries, ...revertEntries],
                usersToNotify: emails,
                isRecurring: currentSubPool?.isRecurring ? true : false,
                notificationMethods: ['email']
            }
            createTemplate(params);
        }
    }

    const handleCancel = () => {
        if (activeTabIndex === 0) { setOpen(false); callPlanHierarchyAPI(); setEditRow(null); clearData(); } else { setActiveTabIndex(activeTabIndex - 1) }
    };

    const handleSubPoolChange = (field: any, value: any) => {
            setCurrentSubPool((prev: any) => ({
                ...prev,
                [field]: value,
            }));
    };

    const renderTabContent = (index: number): JSX.Element | null => {
        switch (index) {
            case 0:
                return <TemplateInfo isEditMode={isEditMode} planPoolToggle={planPoolToggle} handlePlanPoolToggle={handlePlanPoolToggle} currentSubPool={currentSubPool} handleSubPoolChange={handleSubPoolChange} selectedMonthYear={selectedMonthYear} setSelectedMonthYear={setSelectedMonthYear} day={day} setDay={setDay}/>
            case 1:
                return <QuotaActions entries={entries} handleValueChange={handleValueChange} handleRemoveEntry={handleRemoveEntry} revertEntries={revertEntries} handleRevertValueChange={handleRevertValueChange} handleAddEntry={handleAddEntry} handleRemoveRevertEntry={handleRemoveRevertEntry} handleAddRevertEntry={handleAddRevertEntry} />
            case 2:
                return <Notifications emails={emails} handleDeleteEmail={handleDeleteEmail} error={error} setError={setError} emailInput={emailInput} setEmailInput={setEmailInput} handleAddEmail={handleAddEmail} />
            default:
                return null;
        }
    };

    const handleTabChanges = (_: any, index: number) => { handleTabChange(tabs[index], index); };

    const handleValueChange = (index, field, value) => {
        const newEntries = [...entries];
        newEntries[index][field] = value;
        setEntries(newEntries);
    };

    const handleAddEntry = () => {
        setEntries([...entries, { usagePercentage: '100', type: 'sendNotification' }]);
    };

    const validateEmail = (email: string) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
    }

    const handleAddEmail = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter' && emailInput) {
            event.preventDefault();
            if (validateEmail(emailInput)) {
                setEmails([...emails, { name: emailInput.split('@')[0].replace('.', ' ').replace(/\b\w/g, char => char.toUpperCase()), email: emailInput }]);
                setEmailInput('');
                setError('');
            } else {
                setError('Invalid email address');
            }
        }
    };

    const handleRemoveEntry = (index) => {
        const updatedEntries = entries.filter((_, i) => i !== index);
        setEntries(updatedEntries);
    };

    const handleRemoveRevertEntry = (index) => {
        const updatedEntries = revertEntries.filter((_, i) => i !== index);
        setRevertEntries(updatedEntries);
    };

    const handleDeleteEmail = (emailToDelete: string) => {
        setEmails(emails.filter(email => email !== emailToDelete));
    };

    const handleRevertValueChange = (index, field, value) => {
        const newEntries = [...revertEntries];
        newEntries[index][field] = value;
        setRevertEntries(newEntries);
    };

    const handleAddRevertEntry = () => {
        setRevertEntries([...revertEntries, { usagePercentage: 0, type: 'optIn', revert: true }]);
    };

    return (
        <>
            <BaseModal showOnlineOffline={false} showSyncStatus={false} width='800px' open={open} onClose={()=>{setOpen(false); callPlanHierarchyAPI(); setEditRow(null); clearData();}} title={`${isEditMode ? 'Edit' : 'Create'} ${planPoolToggle}`} height="480px" showOnlineStatus={true} onlineStatusText={""} lastSeen={row?.last_seen} showRefreshIcon={false} setRefreshIconClicked={setRefreshIconClicked}>
                <DialogContent className="modal-content-wrapper">
                    <Box
                        className="modal-body"
                        style={{ flexDirection: isSmallScreen ? 'column' : 'row' }}
                    >
                        <SidebarTabs
                            tabs={tabs}
                            activeTab={activeTabIndex}
                            onChange={handleTabChanges}
                            isHorizontal={isSmallScreen}
                        />
                        <Box className="modal-content">
                            <Box className="modal-tab-panel-starlink">{renderTabContent(activeTabIndex)}</Box>
                            {<ModalFooter
                                onClose={handleCancel}
                                onSave={handleSave}
                                cancelText={"Cancel"}
                                saveText={activeTabIndex === 2 ? "Save" : "Next"}
                                disableSave={activeTabIndex === 0 ? !isTemplateInfoValid() : activeTabIndex === 2 ?  (entries?.length > 0 ? emails?.length > 0 ? false : true : false)   : false}
                            />}
                        </Box>
                    </Box>
                </DialogContent>
            </BaseModal>
        </>
    );
};

const mapStateToProps = (state) => ({
    selectedOu: state.authReducer.selectedOu,
    createPlanTemplate: state.starlinkPooled.createPlanTemplate,
    editPlanTemplate: state.starlinkPooled.editPlanTemplate,
});

export default withRouter(
    connect(mapStateToProps, { createTemplate, getStarlinkTemplate, editTemplate })(NewCreatePlanPopup) )